import ForgetPasswordForm from "../../components/common/ForgetPassword";

const ForgetPassword = () => {
    return(
        <ForgetPasswordForm />
    )
}

export default ForgetPassword;